import * as style from "./style";

export const Text = () => {
  return (
    <style.Text>
      <style.Title>ARTIOM BORISOV</style.Title>
      <style.Subtitle>Self-taught Front End Developer,</style.Subtitle>
      <style.Subtitle>University-taught Mining Engineer (MSE)</style.Subtitle>
    </style.Text>
  );
};
